import React, { ReactNode, useReducer } from 'react';
import { StructureCopyContext } from './context';
import { initialData, reducer } from './reducer';

type Props = {
    children: ReactNode;
};

export const StructureCopyProvider = ({ children }: Props) => {
    const [state, dispatch] = useReducer(reducer, initialData);

    return (
        <StructureCopyContext.Provider
            value={{
                state,
                dispatch,
            }}>
            {children}
        </StructureCopyContext.Provider>
    );
};
